export enum EnvironmentType {
    Local,
    Development,
    UAT,
    Production
}
